import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class IconsService {
  private matIconRegistry = inject(MatIconRegistry);
  private sanitizer = inject(DomSanitizer);
  private readonly iconsToRegister = [
    {
      name: 'newspaper',
      path: 'assets/icons/nav/newspaper.svg',
    },
    {
      name: 'file_edit',
      path: 'assets/icons/nav/file_edit.svg',
    },
    {
      name: 'drag_handle',
      path: 'assets/icons/drag_handle.svg',
    },
    {
      name: 'add_btn',
      path: 'assets/icons/add_btn.svg',
    },
    {
      name: 'no_photo',
      path: 'assets/icons/no_photo.svg',
    },
    {
      name: 'books',
      path: 'assets/icons/nav/books.svg',
    }
  ];

  registerAppIcons() {
    this.iconsToRegister.forEach(
      icon => this.matIconRegistry.addSvgIcon(
        icon.name,
        this.sanitizer.bypassSecurityTrustResourceUrl(icon.path))
    );
  }
}
